// extracted by mini-css-extract-plugin
module.exports = {"pdpInstallServiceWrapper":"InstallService_pdpInstallServiceWrapper__B_Xuh"};